import React, { ReactNode } from 'react';
import Typography from 'new/elements/Typography';
import styles from './NodeBar.module.scss';

interface NodeBarProps {
  title: string;
  children?: ReactNode;
}

export const NodeBar: React.FC<NodeBarProps> = ({ title, children }) => {
  return (
    <div className={styles.nodeBar}>
      <div className={styles.nodeInfoContainer}>
        <Typography className={styles.nodeName}>{title}</Typography>
        {children && <div className={styles.content}>{children}</div>}
      </div>
    </div>
  );
};
